export default __webpack_public_path__ + "static/media/ic_forms.546d5afe.svg";